import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { AsiakasJaettuLemonaidService } from '@lemon/core-firebase/service/asiakas-jaettu-lemonaid.service'
import { DateService } from '@lemon/core/service/date.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { KayttajaService } from '../service/kayttaja.service'

@Injectable()
export class TaukoGuard {
  constructor(
    private _router: Router,
    private _kayttajaService: KayttajaService,
    private _asiakasJaettuService: AsiakasJaettuLemonaidService,
    private _dateService: DateService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._kayttajaService.nykyinenAsiakasObservable.pipe(
      map(asiakas => {
        if (!asiakas) {
          return true
        }
        const today = this._dateService.currentLocalDate()
        const sopimuskausi = this._asiakasJaettuService.annaKausiPaivamaaralle(asiakas.sopimuskaudet, today)
        const tauolla = sopimuskausi ? this._asiakasJaettuService.onkoSopimuskausiTauolla(sopimuskausi, today) : false

        if (tauolla) {
          this._router.navigate(['/sopimus-tauolla'])
          return false
        }

        return true
      }),
    )
  }
}
